import { render, staticRenderFns } from "./ListKirimInven.vue?vue&type=template&id=dc380acc&"
import script from "./ListKirimInven.vue?vue&type=script&lang=js&"
export * from "./ListKirimInven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports